import React, {useState} from "react";
import { Fieldset } from "primereact/fieldset";
import { InputText } from "primereact/inputtext";
import { useFormik } from "formik";
import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import { settingService } from "../../../services/extensions";
import { toast } from "react-toastify";
import { Checkbox } from 'primereact/checkbox';

const ActivityForm = ({ onClose }) => {
  const [checked, setChecked] = useState(false);
  const formik = useFormik({
    initialValues: {
      code: "",
      title: "",
    },
    validate: (data) => {
      let errors = {};
      if (!data.code) {
        errors.code = "Code is required.";
      }
      if (!data.title) {
        errors.title = "Title is required.";
      }
      return errors;
    },
    onSubmit: (data) => {
      let param = {
        code: data.code,
        title: data.title,
      };
      createActivity(param);
      formik.resetForm();
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const createActivity = (data) => {
    try {
      settingService.addMasterActivity(data).then(
        (resp) => {
          toast.success("New activity added");
          onClose();
        },
        (err) => {
          toast.error(err.response.data.error);
        }
      );
    } catch (error) {
      toast.error("Unable to add new activity");
    }
  };

  const ActivitiesForm = (
    <Fieldset>
      <form
        onSubmit={formik.handleSubmit}
        className="p-fluid p-grid"
        autoComplete="off"
      >
        <div className="formgrid grid">
          <div className="field col-1 mt-1"></div>
          <div className="field col-3 mt-2">
            {" "}
            <strong>Code: </strong>
          </div>
          <div className="field col-6">
            <span className="p-mt-4 p-input-icon-right">
              <span className="p-float-label">
                <InputText
                  id="code"
                  name="code"
                  value={formik.values.code}
                  onChange={formik.handleChange}
                  className={classNames({
                    "p-invalid": isFormFieldValid("code"),
                  })}
                />
              </span>
              {getFormErrorMessage("code")}
            </span>
          </div>
        </div>

        <div className="formgrid grid">
          <div className="field col-1 mt-1"></div>
          <div className="field col-3 mt-2">
            {" "}
            <strong>Title: </strong>
          </div>
          <div className="field col-6">
            <span className="p-mt-4 p-input-icon-right">
              <span className="p-float-label">
                <InputText
                  id="title"
                  name="title"
                  value={
                    formik.values.title.charAt(0).toUpperCase() +
                    formik.values.title.slice(1)
                  }
                  onChange={formik.handleChange}
                  className={classNames({
                    "p-invalid": isFormFieldValid("title"),
                  })}
                />
              </span>
              {getFormErrorMessage("title")}
            </span>
          </div>
        </div>
        <div className="formgrid grid">
          <div className="field col-1 mt-1"></div>
          <div className="field col-3 mt-2">
            {" "}
            <strong>IsBillable: </strong>
          </div>
          <div className="field col-6">
            <span className="p-mt-4 p-input-icon-right">
              <span className="p-float-label">
                <Checkbox
                  inputId="binary"
                  checked={checked}
                  onChange={e=>setChecked(e.checked)}
                  // {formik.handleChange}
                  // className={classNames({
                  //   "p-invalid": isFormFieldValid("title"),
                  // })}
                />
              </span>
              {/* {getFormErrorMessage("title")} */}
            </span>
          </div>
        </div>
        <div className="formgrid grid" style={{ paddingTop: "20px" }}>
          <div className="field col-3"></div>
          <div className="field col-4">
            <Button
              type="button"
              label="Cancel"
              icon="pi pi-times"
              className="p-button-rounded p-button-secondary p-mt-2"
              onClick={onClose}
            />
          </div>
          <div className="field col-4">
            <Button
              type="submit"
              label="Save"
              icon="pi pi-save"
              className="p-button-rounded p-button-primary p-mt-2"
            />
          </div>
        </div>
      </form>
    </Fieldset>
  );

  return <React.Fragment>{ActivitiesForm}</React.Fragment>;
};

export default ActivityForm;
